import { Link } from "react-router-dom";

import Button from "../moduleComponents/Button";
import logo from "../../assets/img/logo.png";
import { MdSwapHorizontalCircle } from "react-icons/md";
import toggler from "../../assets/img/toggler-icon.png";

const Nav = ({ navLinks, toggle }) => {
  return (
    <div className="w-full py-4 flex items-center nav-glass sticky top-0 z-50">
      <div className="container mx-auto flex px-[6%] items-center">
        <Link to="/">
          <img src={logo} alt="logo" className="drop-shadow-lg hover:scale-105 transition-transform" />
        </Link>

        <ul className="md:flex hidden gap-8 items-center justify-center flex-1 font-Poppins">
          {navLinks.map(({ id, text, path, internal }) => {
            const className =
              "hover:text-[#E71CA5] transition-all text-white/90 hover:text-white duration-300 capitalize text-[15px] font-semibold relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[2px] after:bg-[#E71CA5] after:transition-all after:duration-300 hover:after:w-full";
            return (
              <li key={id}>
                {internal ? (
                  <Link to={path} className={className}>
                    {text}
                  </Link>
                ) : (
                  <a
                    className={className}
                    href={path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {text}
                  </a>
                )}
              </li>
            );
          })}
        </ul>

        <Link
          to="/shitswap"
          className="ml-auto w-[155px] md:w-[180px] h-[40px] md:h-[50px] rounded-full bg-[#E71CA5] hover:bg-[#E71CA5]/90 shadow-glow-pink animate-pulse-glow btn-shine flex items-center justify-center transition-all hover:scale-105"
        >
          <div className="flex items-center text-[10px] md:text-[14px] gap-2 font-Poppins md:text-sm font-bold text-white">
            <MdSwapHorizontalCircle className="text-lg" />
            ShitSwap
          </div>
        </Link>

        <button
          className="text-2xl text-[#E71CA5] md:hidden block"
          onClick={toggle}
        >
          <div className="w-[40px] gradient text-2xl h-[40px] rounded-full bg-white flex items-center justify-center ml-1">
            <img src={toggler} alt="" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Nav;
